import './App.css';
import { useState, useEffect, Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import Home from './Pages/User/Home/Home';
import Registration from './Pages/User/Registration/Registration';
import NoPage from './Pages/NoPage';
import Verification from './Pages/User/Verification/Verification';
import Todo from './Pages/User/Todo/Todo';
import Login from './Pages/User/Login/Login';
import BusinessDetails from './Pages/User/BusinessDetails/BusinessDetails';
import FileUpload from './Pages/User/FileUpload/FileUpload';
import AdminLogin from './Pages/Admin/AdminLogin/AdminLogin';
import AdminDashboardAdvertisers from './Pages/Admin/AdminDashboardAdvertisers/AdminDashboardAdvertisers';
import AdminDashboardHome from './Pages/Admin/AdminDashboardHome/AdminDashboardHome';
import AdminDashboardScreens from './Pages/Admin/AdminDashboardScreens/AdminDashboardScreens';
import AdminDashboardScreenHome from './Pages/Admin/AdminDashboardScreens/AdminDashboardScreenHome/AdminDashboardScreenHome';
import AdvertisersHome from './Pages/Admin/AdminDashboardAdvertisers/AdvertisersHome/AdvertisersHome';
import CreateAdvertiser from './Pages/Admin/AdminDashboardAdvertisers/CreateAdvertiser/CreateAdvertiser';
import AdminCreateCampaign from './Pages/Admin/AdminDashboardAdvertisers/CreateCampaign/AdminCreateCampaign';
import { useLocation, useNavigate } from 'react-router-dom';
import AdvertiserLogin from './Pages/Advertiser/AdvertiserLogin/AdvertiserLogin';
import AdvertiserSignup from './Pages/Advertiser/AdvertiserSignup/AdvertiserSignup';
import AdvertiserActivate from './Pages/Advertiser/AdvertiserActivate/AdvertiserActivate';
import AdvertiserAdvertisingAgreement from './Pages/Advertiser/AdvertiserAdvertisingAgreement/AdvertiserAdvertisingAgreement';
import AdvertiserDashboardAdvertisingAgreement from './Pages/Advertiser/AdvertiserDashboard/AdvertiserDashboardAdvertisingAgreement/AdvertiserDashboardAdvertisingAgreement';
import AdvertiserDashboardHome from './Pages/Advertiser/AdvertiserDashboard/AdvertiserDashboardHome/AdvertiserDashboardHome';
import AdvertiserDashboardCampaigns from './Pages/Advertiser/AdvertiserDashboard/AdvertiserDashboardCampaigns/AdvertiserDashboardCampaigns';
import AdvertiserDashboardNewCampaign from './Pages/Advertiser/AdvertiserDashboard/AdvertiserDashboardNewCampaign/AdvertiserDashboardNewCampaign';
import AdvertiserNewCampaignStripeSuccess from './Pages/Advertiser/AdvertiserDashboard/AdvertiserDashboardNewCampaign/AdvertiserNewCampaignStripeSuccess';
import AdvertiserDashboardPrepay from './Pages/Advertiser/AdvertiserDashboard/AdvertiserDashboardPrepay/AdvertiserDashboardPrepay';
import AdvertiserPrepayStripeSuccess from './Pages/Advertiser/AdvertiserDashboard/AdvertiserDashboardPrepay/AdvertiserPrepayStripeSuccess';
import AdvertiserCompletePrepaidCampaign from './Pages/Advertiser/AdvertiserDashboard/AdvertiserCompletePrepaidCampaign/AdvertiserCompletePrepaidCampaign';
import AdvertiserDashboardRenewCampaign from './Pages/Advertiser/AdvertiserDashboard/AdvertiserDashboardRenewCampaign/AdvertiserDashboardRenewCampaign';
import AdvertiserRenewStripeSuccess from './Pages/Advertiser/AdvertiserDashboard/AdvertiserDashboardRenewCampaign/AdvertiserRenewStripeSuccess';
import LinkNewScreen from './Pages/User/LinkNewScreen/LinkNewScreen';
import ZelleDetails from './Pages/User/ZelleDetails/ZelleDetails';
import ApplicationUnderReview from './Pages/User/ApplicationUnderReview/ApplicationUnderReview';
import AdminDashboardUsersHome from './Pages/Admin/AdminDashboardUsers/AdminDashboardUsersHome/AdminDashboardUsersHome';
import AdminDashboardUsers from './Pages/Admin/AdminDashboardUsers/AdminDashboardUsers';
import AdminDashboardUsersDetails from './Pages/Admin/AdminDashboardUsers/AdminDashboardUsersDetails/AdminDashboardUsersDetails';
import ScreenHostsHome from './Pages/Admin/AdminDashboardUsers/ScreenHostsHome/ScreenHostsHome';
import CreateScreenHost from './Pages/Admin/AdminDashboardUsers/CreateScreenHost/CreateScreenHost';
import ScreenHostDetails from './Pages/Admin/AdminDashboardUsers/ScreenHostDetails/ScreenHostDetails';
import ScreenHostAgreement from './Pages/ScreenHost/ScreenHostAgreement/ScreenHostAgreement';
import ScreenHostLogin from './Pages/ScreenHost/ScreenHostLogin/ScreenHostLogin';
import ScreenHostSignup from './Pages/ScreenHost/ScreenHostSignup/ScreenHostSignup';
import ScreenHostAccept from './Pages/ScreenHost/ScreenHostAccept/ScreenHostAccept';
import AdminAdDisplayLogs from './Pages/Admin/AdminAdDisplayLogs/AdminAdDisplayLogs';
import AdvertiserDetails from './Pages/Admin/AdminDashboardAdvertisers/AdvertiserDetails/AdvertiserDetails';
import AdminDashboardAdvertiserCampaignDetails from './Pages/Admin/AdminDashboardAdvertisers/AdvertiserDetails/CampaignDetails/AdvertiserCampaignDetails';
import AdvertiserCampaignDetails from './Pages/Advertiser/AdvertiserDashboard/AdvertiserDashboardCampaigns/AdvertiserCampaignDetails/AdvertiserCampaignDetails';
import AdvertiserScreenInfo from './Pages/Advertiser/AdvertiserDashboard/AdvertiserScreenInfo/AdvertiserScreenInfo';
import AdvertiserAdDisplayLogs from './Pages/Advertiser/AdvertiserAdDisplayLogs/AdvertiserAdDisplayLogs';
import ContactUs from './Pages/ContactUs/ContactUs';
import MarketingHome from './marketing/pages/Home';
import Product from './marketing/pages/Product';
import Applications from './marketing/pages/Applications';
import Pricing from './marketing/pages/Pricing';
import ForBusiness from './marketing/pages/ForBusiness';
import RestaurantTv from './marketing/pages/RestaurantTv';
import Advertise from './marketing/pages/Advertise';
import AdvertiserLanding from './marketing/advertiser/AdvertiserLanding';
import Network from './marketing/pages/Network';
import Proof from './marketing/pages/Proof';
import AiComposer from './Pages/User/AiComposer/AiComposer';
import ContentLibrary from './Pages/User/ContentLibrary/ContentLibrary';
import ScreenHostShell from './Pages/User/ScreenHostShell/ScreenHostShell';
import ScreenHostTeamManagement from './Pages/User/ScreenHostTeamManagement/ScreenHostTeamManagement';
import UserDashboardHome from './Pages/User/UserDashboard/UserDashboardHome/UserDashboardHome';
import UserDashboardScreenInformation from './Pages/User/UserDashboard/UserDashboardScreenInformation/UserDashboardScreenInformation';
import TOS from './Pages/TOS/TOS';
import AdminLegalDocuments from './Pages/Admin/AdminLegalDocuments/AdminLegalDocuments';
import AdminDashboardContentReview from './Pages/Admin/AdminDashboardContentReview/AdminDashboardContentReview';
import Launch from './Pages/Launch/Launch';
import LaunchSuccess from './Pages/Launch/LaunchSuccess';
import LaunchContinue from './Pages/Launch/LaunchContinue';
import LaunchCancel from './Pages/Launch/LaunchCancel';
import { useDispatch } from 'react-redux';
import { save } from './features/token/tokenSaver';
import { refreshJWT } from './services/refreshJWT';
import { clearRoleSession, getRefreshIdentifier, getRoleLoginPath, getRoleToken, getStoredRole, persistRoleSession } from './services/authSession';
import { getUserAccessToken, getUserSession, clearUserSession } from './services/userSession';
import { resetAuthInterceptorState } from './services/axiosInterceptor';
import AffiliateRedirect from './components/AffiliateRedirect/AffiliateRedirect';
import QrRedirect from './components/QrRedirect/QrRedirect';

const AdminDashboard = lazy(() => import('./Pages/Admin/AdminDashboard/AdminDashboard'));
const AdminDashboardScreenDetails = lazy(() => import('./Pages/Admin/AdminDashboardScreens/AdminDashboardScreenDetails/AdminDashboardScreenDetails'));
const AdvertiserDashboard = lazy(() => import('./Pages/Advertiser/AdvertiserDashboard/AdvertiserDashboard'));
const UserDashboard = lazy(() => import('./Pages/User/UserDashboard/UserDashboard'));

const LOGIN_PATHS = new Set([
  '/adminLogin',
  '/advertiserLogin',
  '/userLogin',
  '/screenHostLogin',
]);

const normalizePath = (path) => (path || '/').replace(/\/+$/, '') || '/';

const isLoginPath = (path) => LOGIN_PATHS.has(normalizePath(path));

function RouteLoadingFallback() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Inter-Regular' }}>
      Loading dashboard…
    </div>
  );
}

export default function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [authBootstrapped, setAuthBootstrapped] = useState(false);
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const [isAdvertiserAuthenticated, setIsAdvertiserAuthenticated] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const setAuthenticatedRole = (role) => {
      if (!isMounted) {
        return;
      }
      setIsAdminAuthenticated(role === 'admin');
      setIsAdvertiserAuthenticated(role === 'advertiser');
      setAuthBootstrapped(true);
    };

    const validateToken = async (token) => {
      const response = await fetch(process.env.REACT_APP_API_URL + "/checkJWT", {
        headers: {
          'Authorization': token
        }
      });

      if (!response.ok) {
        const error = new Error(`HTTP ${response.status}`);
        error.status = response.status;
        throw error;
      }

      return response.json();
    };

    const isAuthFailureStatus = (status) => status === 401 || status === 403;

    const handleLoggedOutState = (role) => {
      dispatch(save(""));
      clearRoleSession();
      clearUserSession();
      resetAuthInterceptorState();
      setAuthenticatedRole(null);

      if (!role) {
        return;
      }

      const loginPath = normalizePath(getRoleLoginPath(role));
      if (normalizePath(location.pathname) === loginPath) {
        return;
      }

      navigate(getRoleLoginPath(role), { 
        replace: true,
        state: { sessionExpired: true }
      });
    };

    const bootstrapAuth = async () => {
      if (isLoginPath(location.pathname)) {
        dispatch(save(""));
        clearRoleSession();
        clearUserSession();
        resetAuthInterceptorState();
        setAuthenticatedRole(null);
        return;
      }

      const role = getStoredRole();
      const refreshToken = localStorage.getItem('refreshToken');
      const storedToken = role ? getRoleToken(role) : null;

      if (!role) {
        const screenHostSession = getUserSession();
        if (screenHostSession?.token || getUserAccessToken()) {
          setAuthBootstrapped(true);
          return;
        }
        handleLoggedOutState(null);
        return;
      }

      if (storedToken) {
        try {
          const validationResponse = await validateToken(storedToken);
          if (validationResponse.level !== role) {
            throw new Error('Token validation failed');
          }

          if (role === 'user') {
            setAuthenticatedRole(null);
            return;
          }

          dispatch(save(storedToken));
          persistRoleSession({
            role,
            token: storedToken,
            refreshToken,
            name: localStorage.getItem('name')
          });
          setAuthenticatedRole(role);
          return;
        } catch (error) {
          if (isAuthFailureStatus(error?.status)) {
            if (role === 'user') {
              setAuthenticatedRole(null);
              return;
            }
            handleLoggedOutState(role);
            return;
          }

          console.error(`${role} token validation failed:`, error.message);
        }
      }

      const identifier = getRefreshIdentifier(refreshToken);
      if (refreshToken && identifier) {
        try {
          const refreshResponse = await refreshJWT(refreshToken, identifier);
          const refreshedToken = refreshResponse.data.token;
          const refreshedRefreshToken = refreshResponse.data.newRefreshToken;
          const validationResponse = await validateToken(refreshedToken);

          if (validationResponse.level !== role) {
            throw new Error('Refreshed token validation failed');
          }

          if (role === 'user') {
            setAuthenticatedRole(null);
            return;
          }

          dispatch(save(refreshedToken));
          persistRoleSession({
            role,
            token: refreshedToken,
            refreshToken: refreshedRefreshToken,
            name: localStorage.getItem('name')
          });
          setAuthenticatedRole(role);
          return;
        } catch (error) {
          if (isAuthFailureStatus(error?.response?.status || error?.status)) {
            if (role === 'user') {
              setAuthenticatedRole(null);
              return;
            }
            handleLoggedOutState(role);
            return;
          }

          console.error(`${role} token refresh failed:`, error.message);
        }
      }

      if (role === 'user') {
        setAuthenticatedRole(null);
        return;
      }

      handleLoggedOutState(role);
    };

    bootstrapAuth();

    return () => {
      isMounted = false;
    };
  }, []);

  if (!authBootstrapped) {
    return null;
  }

  return (
    <>
    <Suspense fallback={<RouteLoadingFallback />}>
    <Routes>
      

        <Route path="/" element={<MarketingHome />} />
        <Route path="/product" element={<Product />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/for-business" element={<ForBusiness />} />
        <Route path="/restaurant-tv" element={<RestaurantTv />} />
        <Route path="/restaurant-tv-box" element={<Navigate to="/restaurant-tv" replace />} />
        <Route path="/restaurant-tv-content" element={<Navigate to="/restaurant-tv" replace />} />
        <Route path="/restaurants" element={<Navigate to="/restaurant-tv" replace />} />
        <Route path="/advertise" element={<Advertise />} />
        <Route path="/advertisers" element={<AdvertiserLanding />} />
        <Route path="/network" element={<Network />} />
        <Route path="/proof" element={<Proof />} />
        <Route path="/screens-info" element={<Navigate to="/for-business" replace />} />
        <Route path="/advertiser-info" element={<Navigate to="/advertise" replace />} />
        <Route path="/our-network" element={<Navigate to="/network" replace />} />
        <Route path="/tos" element={<TOS />} />
        <Route path="/advertiser-advertising-agreement" element={<AdvertiserAdvertisingAgreement />} />
        <Route path="/screen-host-agreement" element={<ScreenHostAgreement />} />
        <Route path="/screenHostLogin/" element={<ScreenHostLogin />} />
        <Route path="/screenHostSignup" element={<ScreenHostSignup />} />
        <Route path="/screen-host/accept" element={<ScreenHostAccept />} />
        <Route path="/launch/success" element={<LaunchSuccess />} />
        <Route path="/launch/continue" element={<LaunchContinue />} />
        <Route path="/launch/cancel" element={<LaunchCancel />} />
        <Route path="/launch" element={<Launch />} />
        <Route path="/qr" element={<QrRedirect />} />
        <Route path="/affiliate/flyer/:affiliateCode" element={<AffiliateRedirect to="/contactUs" />} />
        <Route path="/affiliate/advertiser/:affiliateCode" element={<AffiliateRedirect to="/advertiserSignup" />} />
        <Route path="/affiliate/host/:affiliateCode" element={<AffiliateRedirect to="/screenHostSignup" />} />
        <Route path="/userHome" element={<Home />} />
      <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/user/home" element={<Home />} />
        <Route path="/user/register/" element={<Registration />} />
        <Route path="/userVerification/" element={<Verification />} />
        <Route path="/user/compose" element={<ScreenHostShell><AiComposer /></ScreenHostShell>} />
        <Route path="/user/screens" element={<ScreenHostShell><UserDashboardHome /></ScreenHostShell>} />
        <Route path="/user/library" element={<ScreenHostShell><ContentLibrary /></ScreenHostShell>} />
        <Route path="/user/team" element={<ScreenHostShell><ScreenHostTeamManagement /></ScreenHostShell>} />
        <Route path="/user/userDashboard/" element={<UserDashboard />} >
          <Route path="" element={<Navigate to="/user/compose" replace />} />
          <Route path="/user/userDashboard/screenInfo" element={<UserDashboardScreenInformation />} />
          </Route>
        <Route path="/user/todo/" element={<Todo />} />
        <Route path="/userLogin/" element={<Login />} />
        <Route path="/user/businessDetails/" element={<BusinessDetails />} />
        <Route path="/user/linkNewScreen/" element={<LinkNewScreen />} />
        <Route path="/user/applicationUnderReview/" element={<ApplicationUnderReview />} />
        <Route path="/user/zelleDetails/" element={<ZelleDetails />} />
        <Route path="/user/fileUpload/" element={<FileUpload />} />
      <Route path="/adminLogin/" element={<AdminLogin />} />
      <Route path="/advertiserLogin/" element={<AdvertiserLogin />} />
      <Route path="/advertiserSignup" element={<AdvertiserSignup />} />
      {isAdminAuthenticated &&

      <Route path="/adminDashboard/" element={<AdminDashboard />} >
          <Route path="" element={<AdminDashboardHome />} />
            <Route path="/adminDashboard/home" element={<AdminDashboardHome />} />
            <Route path="/adminDashboard/advertisers" element={<AdminDashboardAdvertisers />} >
            <Route path="" element={<AdvertisersHome />} />
            <Route path="/adminDashboard/advertisers/home"  element={<AdvertisersHome />} />
            <Route path="/adminDashboard/advertisers/create" element={<CreateAdvertiser />} />
            <Route path="/adminDashboard/advertisers/details/:id" element={<AdvertiserDetails />} />
            <Route path="/adminDashboard/advertisers/details/:id/createCampaign" element={<AdminCreateCampaign />} />
            <Route path="/adminDashboard/advertisers/campaignDetails" element={<AdminDashboardAdvertiserCampaignDetails />} />
          </Route>
          <Route path="/adminDashboard/screens" element={<AdminDashboardScreens />} >
            <Route path="" element={<AdminDashboardScreenHome />} />
            <Route path="/adminDashboard/screens/home" element={<AdminDashboardScreenHome />} />
            <Route path="/adminDashboard/screens/details" element={<AdminDashboardScreenDetails />} />
            <Route path="/adminDashboard/screens/details/:screenId" element={<AdminDashboardScreenDetails />} />

          </Route>
             <Route path="/adminDashboard/users" element={<AdminDashboardUsers />} >
            <Route path="" element={<AdminDashboardUsersHome />} />
            <Route path="/adminDashboard/users/home" element={<AdminDashboardUsersHome />} />
            <Route path="/adminDashboard/users/hosts" element={<ScreenHostsHome />} />
            <Route path="/adminDashboard/users/create" element={<CreateScreenHost />} />
            <Route path="/adminDashboard/users/host/:userId" element={<ScreenHostDetails />} />
            <Route path="/adminDashboard/users/details" element={<AdminDashboardUsersDetails />} />

          </Route>
          <Route path="/adminDashboard/displayLog" element={<AdminAdDisplayLogs />} />
          <Route path="/adminDashboard/contentReview" element={<AdminDashboardContentReview />} />
          <Route path="/adminDashboard/legal" element={<AdminLegalDocuments />} />
        </Route>
      }
      {isAdvertiserAuthenticated &&
        <Route path="/advertiserActivate" element={<AdvertiserActivate />} />
      }
      {isAdvertiserAuthenticated &&
        <Route path="/advertiserDashboard/" element={<AdvertiserDashboard />} >
          <Route path="" element={<AdvertiserDashboardHome />} />

          <Route path="/advertiserDashboard/home" element={<AdvertiserDashboardHome />} />
          <Route path="/advertiserDashboard/campaigns" element={<AdvertiserDashboardCampaigns />} />
          <Route path="/advertiserDashboard/newCampaign" element={<AdvertiserDashboardNewCampaign />} />
          <Route path="/advertiserDashboard/newCampaign/stripe-success" element={<AdvertiserNewCampaignStripeSuccess />} />
          <Route path="/advertiserDashboard/prepay" element={<AdvertiserDashboardPrepay />} />
          <Route path="/advertiserDashboard/prepay/stripe-success" element={<AdvertiserPrepayStripeSuccess />} />
          <Route path="/advertiserDashboard/completePrepaid" element={<AdvertiserCompletePrepaidCampaign />} />
          <Route path="/advertiserDashboard/renewCampaign" element={<AdvertiserDashboardRenewCampaign />} />
          <Route path="/advertiserDashboard/renewCampaign/stripe-success" element={<AdvertiserRenewStripeSuccess />} />
          <Route path="/advertiserDashboard/campaignDetails" element={<AdvertiserCampaignDetails />} />
          <Route path="/advertiserDashboard/screen/:screenId" element={<AdvertiserScreenInfo />} />
          <Route path="/advertiserDashboard/displayLog" element={<AdvertiserAdDisplayLogs />} />
          <Route path="/advertiserDashboard/advertising-agreement" element={<AdvertiserDashboardAdvertisingAgreement />} />
        </Route>
      }
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
    </>
  );
}

